/**
 * Common medical specialisations for lead enquiry dropdown (hospital CRM).
 * Alphabetically sorted; Plastic Surgery & Obstetrics / Gynecology included.
 */
export const MEDICAL_SPECIALISATIONS: string[] = [
  'Allergology / Immunology',
  'Anesthesiology',
  'Ayurveda',
  'Cardiology',
  'Cardiothoracic Surgery',
  'Cosmetic / Aesthetic Medicine',
  'Critical Care / ICU',
  'Dentistry',
  'Dermatology',
  'Diabetology',
  'Emergency Medicine',
  'Endocrinology',
  'ENT (Otorhinolaryngology)',
  'Family Medicine / General Practice',
  'Gastroenterology',
  'General Surgery',
  'Geriatrics',
  'Gynecology & Obstetrics',
  'Hematology',
  'Hepatology',
  'Infectious Diseases',
  'Internal Medicine',
  'Laboratory Medicine / Pathology',
  'Nephrology',
  'Neonatology',
  'Neurology',
  'Neurosurgery',
  'Nuclear Medicine',
  'Oncology (Medical)',
  'Oncology (Radiation)',
  'Oncology (Surgical)',
  'Ophthalmology',
  'Orthopedics',
  'Pain Medicine',
  'Pediatrics',
  'Physical Medicine & Rehabilitation',
  'Plastic Surgery',
  'Plastic & Reconstructive Surgery',
  'Psychiatry',
  'Pulmonology / Respiratory Medicine',
  'Radiology',
  'Rheumatology',
  'Sexual Medicine',
  'Sports Medicine',
  'Urology',
  'Vascular Surgery',
  'Other / Not listed',
].sort((a, b) => a.localeCompare(b));
